import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'


const _hoisted_1 = { class: "grid grid-cols-6 gap-6 py-6" }
const _hoisted_2 = { class: "py-2" }
const _hoisted_3 = { class: "py-2" }
const _hoisted_4 = { class: " grid grid-cols-4 gap-1" }
const _hoisted_5 = { class: "text-12px text-gray-lp-600 mt-3" }
const _hoisted_6 = { class: "mb-10 relative" }
const _hoisted_7 = { class: "col-span-6 space-y-3 mt-5" }
const _hoisted_8 = { class: "w-full flex flex-row items-start gap-x-3" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "max-w-max py-5" }, [
  /*#__PURE__*/_createVNode("span", { class: "text-14px font-semibold" }, "Captcha")
], -1)
const _hoisted_10 = { class: "w-full flex flex-col" }
const _hoisted_11 = { class: "w-2/5" }
const _hoisted_12 = { class: "\n                    w-full\n                    text-red-lp-100 text-12px\n                    xxl:text-14px\n                    flex flex-row\n                    gap-x-2\n                  " }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_14 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_UploadImageWide = _resolveComponent("UploadImageWide")!
  const _component_UploadImageTiny = _resolveComponent("UploadImageTiny")!
  const _component_CheckboxV2 = _resolveComponent("CheckboxV2")!
  const _component_Captcha = _resolveComponent("Captcha")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_card = _resolveComponent("card")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    fullPage: "",
    verticalSeparator: false,
    customClass: "px-0",
    onBack: _ctx.goBack,
    title: _ctx.getTitle,
    loading: _ctx.isLoading,
    error: _ctx.isError,
    errorType: _ctx.errorCause,
    onTryAgain: _ctx.getDetail
  }, {
    data: _withCtx(() => [
      _createVNode(_component_card, { class: "px-5 pb-5 w-600px relative" }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_DataWrapper, {
              label: "No. STT",
              class: "col-span-6",
              value: _ctx.shipmentDetail.sttNo
            }, null, 8, ["value"]),
            _createVNode(_component_DataWrapper, {
              label: "Email",
              class: "col-span-3",
              value: "claim@thelionparcel.com"
            }),
            _createVNode(_component_DataWrapper, {
              label: "No. Handphone",
              class: "col-span-3",
              value: _ctx.numberPhone
            }, null, 8, ["value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('trackDelivery.partyRequest'),
              class: "col-span-3 py-2",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_2, [
                  _createVNode(_component_CustomDropdown, {
                    isExpand: _ctx.isOpenClaimer,
                    "onUpdate:isExpand": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpenClaimer = $event)),
                    options: _ctx.claimerData,
                    onSelect: _ctx.onSelectClaimer,
                    placeholder: _ctx.$t('trackDelivery.chooseClaimer'),
                    selectedItem: _ctx.claimer,
                    isDisabled: ""
                  }, null, 8, ["isExpand", "options", "onSelect", "placeholder", "selectedItem"])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('trackDelivery.cliamType'),
              class: "col-span-3 py-2",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_3, [
                  _createVNode(_component_CustomDropdown, {
                    isExpand: _ctx.isOpenTypeClaimer,
                    "onUpdate:isExpand": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpenTypeClaimer = $event)),
                    options: _ctx.claimerTypeData,
                    onSelect: _ctx.onSelectClaimerType,
                    placeholder: _ctx.$t('trackDelivery.chooseClaimType'),
                    selectedItem: _ctx.claimerType
                  }, null, 8, ["isExpand", "options", "onSelect", "placeholder", "selectedItem"])
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _withDirectives(_createVNode("div", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.docs, (doc, index) => {
              return (_openBlock(), _createBlock(_component_DataWrapper, {
                key: index,
                label: doc.title,
                class: "col-span-3 mb-5",
                asterisk: index < 3,
                optional: index === 3
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UploadImageWide, {
                    title: doc.caption,
                    caption: "Format .png. jpg. jpeg 2MB",
                    buttonCaption: _ctx.$t('trackDelivery.changePhoto'),
                    isWarning: "",
                    warningCaption: doc.warning,
                    maxSize: 2,
                    modelValue: _ctx.documentModel[index],
                    "onUpdate:modelValue": ($event: any) => (_ctx.documentModel[index] = $event)
                  }, null, 8, ["title", "buttonCaption", "warningCaption", "modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["label", "asterisk", "optional"]))
            }), 128))
          ], 512), [
            [_vShow, 
            _ctx.claimerType.value === 'LOST' || _ctx.claimerType.value === 'DAMAGED'
          ]
          ]),
          _withDirectives(_createVNode(_component_DataWrapper, {
            label: _ctx.$t('trackDelivery.itemPhoto'),
            class: "col-span-3 mb-5",
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_4, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.packagePhotos, (photo, index) => {
                  return (_openBlock(), _createBlock("div", { key: index }, [
                    _createVNode(_component_UploadImageTiny, {
                      title: photo,
                      modelValue: _ctx.picModel[index],
                      "onUpdate:modelValue": ($event: any) => (_ctx.picModel[index] = $event),
                      maxSize: 2
                    }, null, 8, ["title", "modelValue", "onUpdate:modelValue"])
                  ]))
                }), 128))
              ]),
              _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('trackDelivery.itemPhotoDesc')), 1)
            ]),
            _: 1
          }, 8, ["label"]), [
            [_vShow, _ctx.claimerType.value === 'DAMAGED']
          ]),
          _createVNode("div", _hoisted_6, [
            _withDirectives(_createVNode(_component_CheckboxV2, {
              value: _ctx.isComplete,
              ref: "defaultCheck",
              "onUpdate:value": _ctx.onComplete,
              label: _ctx.$t('trackDelivery.isDataValid'),
              labelWeight: "normal",
              class: "col-span-6"
            }, null, 8, ["value", "onUpdate:value", "label"]), [
              [_vShow, _ctx.isShowAgreement]
            ]),
            _withDirectives(_createVNode("div", _hoisted_7, [
              _createVNode(_component_Captcha, {
                modelValue: _ctx.captcha,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.captcha = $event)),
                onResetCaptcha: _ctx.resetCaptcha
              }, null, 8, ["modelValue", "onResetCaptcha"]),
              _createVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode(_component_lp_input, {
                      modelValue: _ctx.captchaInput,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.captchaInput = $event)),
                      onChange: _ctx.checkCaptcha
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode("span", null, _toDisplayString(_ctx.$t('trackDelivery.codeInvalid')), 1)
                  ], 512), [
                    [_vShow, _ctx.isErrorCaptcha]
                  ])
                ])
              ])
            ], 512), [
              [_vShow, _ctx.isComplete]
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode(_component_LpButton, {
              title: _ctx.$t('trackDelivery.columns.submitClaim'),
              textColor: "white",
              disabled: _ctx.isDisabledClaim,
              onClick: _ctx.onClaim
            }, null, 8, ["title", "disabled", "onClick"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]))
}